import React from 'react';
import { Button } from 'react-bootstrap';
import { startBikefit } from '../../../../components/Bikefit/lib/bikefit';
import { useTranslation } from 'react-i18next';
import ReactGA from "react-ga4";
import {trackBikefitCTA} from "../../../../lib/mixpanelClient";
import useObjectFeatureFlag from '../../../../hooks/useObjectFeatureFlag';

const BikeFittingButton = ({ buttonColor, textColor, className }) => {
  const { t } = useTranslation()

  const ctaBgColor = useObjectFeatureFlag("bikefitting_cta_bg_color");
  const isBikefittingPage = typeof window !== 'undefined' && window.location.pathname.includes('/bikefitting');

  const bikefitClicked = () => {
    ReactGA.event({
      action: 'click',
      category: 'bikefit_home_start',
      label: `Start bikefit from the home page`,
      value: 0
    });

    trackBikefitCTA('bikefitting');

    startBikefit();
  }

  return (
    <Button variant='' style={{ backgroundColor: isBikefittingPage ? ctaBgColor.background : buttonColor, color: isBikefittingPage ? ctaBgColor.text : textColor }} className={`custom-button cta ${className}`} onClick={bikefitClicked}>{t("bikeFittingBtn")}</Button>
  );
};

export default BikeFittingButton;